import React, { useState } from 'react';
import { availabilityAPI } from '../services/api';

const CancelClockInButton = ({ userId, date, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleCancel = async () => {
    if (!window.confirm('Cancel this user\'s clock-in for this day?')) return;
    setLoading(true);
    setError('');
    try {
      await availabilityAPI.cancelClockIn(userId, date);
      if (onSuccess) onSuccess();
    } catch (e) {
      setError('Failed to cancel clock-in');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button type="button" onClick={handleCancel} disabled={loading} style={{ color: 'red', fontWeight: 'bold' }}>
        {loading ? 'Cancelling...' : 'Cancel Clock-In'}
      </button>
      {error && <span style={{ color: 'red', marginLeft: 8 }}>{error}</span>}
    </>
  );
};

export default CancelClockInButton;
